import React from "react";
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { EmployeeLink } from 'components/Employees/EmployeeEditDrawer';
import { FiEdit3, FiMail, FiPhone, FiCalendar } from "react-icons/fi";
import Avatar from "components/Avatar";
import { hasSubscriptionFeature } from "utils/utils";
import UpgradeModal from "components/Modal/UpgradeModal";

class AbsenceSidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showUpgradeModal: false,
            upgradeFeature: "",
        };
    }

    openAvatarModal = () => {
        const { t } = this.props;
        this.props.showModal(
            {
                open: true,
                title: t("absences.sidebar.editAvatar"),
                style: { width: "300px" },
                content: (
                    <AvatarEdit
                        userId={this.props.employee.id}
                        onClose={() => this.props.hideModal()}
                    />
                ),
                closeModal: this.props.hideModal,
            },
            "empty"
        );
    };

    openPlanModal = () => {
        // placeholder para abrir el modal de plan del empleado
    };

    // Helper to format vacation values
    format = (val) => val?.toLocaleString(undefined, { maximumFractionDigits: 2 }) || 0;

    getDotStyle = (colorHex) => {
        let c = colorHex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        const r = (c >> 16) & 255;
        const g = (c >> 8) & 255;
        const b = c & 255;

        return {
            backgroundColor: `rgba(${r}, ${g}, ${b}, 0.5)`,
            border: `1px solid ${colorHex}`
        };
    };

    render() {
        const { t, employee, vacationData, history } = this.props;

        if (!employee) return null;

        const {
            vacation_entitlement,
            vacation_taken_already_done,
            vacation_taken_not_done,
            vacation_pending,
        } = vacationData || {};

        const COLORS = {
            yellow: '#efc54d',
            blue: '#55a2e6',
            green: '#0a8a0a',
            red: '#dd377a',
            blueDark: '#102cba',
            purple: '#887bfe',
            orange: '#f29a0c',
            grey: '#55536b',
        };

        const CUSTOM_COLORS_ORDER = [
            COLORS.red,
            COLORS.blue,
            COLORS.green,
            COLORS.yellow,
            COLORS.blueDark,
            COLORS.purple,
            COLORS.orange,
            COLORS.grey
        ];

        return (
            <div className="employee-sidebar">
                <div className="profile-section">
                    <div className="avatar-container">
                        <EmployeeLink
                            as="button"
                            employee={employee}
                            title={this.props.t('absences.viewEmployeeProfile')}
                            style={{
                                padding: 0,
                                background: "transparent",
                                border: 0,
                                cursor: "pointer",
                                borderRadius: "50%",
                                lineHeight: 0,
                            }}
                        >
                            <Avatar
                                userId={employee.id}
                                className="avatar-large"
                                alt={employee.name}
                            />
                        </EmployeeLink>
                    </div>

                    <div className="employee-data">
                        <h2 className="employee-data-name">
                            <EmployeeLink employee={employee} style={{ color: 'inherit', textDecoration: 'none' }}>
                                {employee.name} {employee.surname}
                            </EmployeeLink>
                        </h2>

                        <p className="employee-data-position">{employee.position || t("absences.noPosition")}</p>

                        <div className="employee-data-contact-info">
                            {employee.email && (
                                <a href={`mailto:${employee.email}`} className="employee-data-contact-item">
                                    <FiMail />
                                    {employee.email}
                                </a>
                            )}
                            {employee.phone && (
                                <a href={`tel:${employee.phone}`} className="employee-data-contact-item">
                                    <FiPhone />
                                    {employee.phone}
                                </a>
                            )}
                        </div>
                    </div>
                </div>

                <div className="employee-action-buttons">
                    {(() => {
                        const hasMyCalendarSubscription = hasSubscriptionFeature('MY_CALENDAR');
                        return (
                            <button
                                className={`action-btn action-btn-calendario ${!hasMyCalendarSubscription ? 'disabled-subscription' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (hasMyCalendarSubscription) {
                                        window.open(`/calendar?employee=${employee.id}`, '_blank');
                                    } else {
                                        this.setState({
                                            showUpgradeModal: true,
                                            upgradeFeature: t("absences.sidebar.calendar")
                                        });
                                    }
                                }}
                                style={{
                                    opacity: !hasMyCalendarSubscription ? 0.5 : 1,
                                    cursor: !hasMyCalendarSubscription ? 'not-allowed' : 'pointer',
                                    width: '100%'
                                }}
                            >
                                {t("absences.sidebar.calendar")}
                            </button>
                        );
                    })()}
                    <button
                        className="action-btn action-btn-fichajes"
                        onClick={() => history.push(`/times/${employee.id}/employee`)}
                    >
                        {t("absences.sidebar.timeLogs")}
                    </button>
                </div>

                <div className="holidays-section" style={{ marginTop: '20px' }}>
                    <h3 style={{ marginBottom: '10px', fontSize: '16px', fontWeight: 'bold' }}>{t("absences.vacation.byType")}</h3>

                    <div className="holidays-item">
                        <div className="holidays-key">{t("absences.vacation.generated")}</div>
                        <div className="holidays-value">{this.format(vacation_entitlement)}</div>
                    </div>

                    <div className="holidays-item">
                        <div className="holidays-key">{t("absences.vacation.taken")}</div>
                        <div className="holidays-value">{this.format(vacation_taken_already_done)}</div>
                    </div>

                    <div className="holidays-item">
                        <div className="holidays-key">{t("absences.vacation.planned")}</div>
                        <div className="holidays-value">{this.format(vacation_taken_not_done)}</div>
                    </div>

                    <div className="holidays-item">
                        <div className="holidays-key">{t("absences.vacation.available")}</div>
                        <div className="holidays-value">{this.format(vacation_pending)}</div>
                    </div>

                    {this.props.customCounters && this.props.customCounters.map((counter, idx) => (
                        <div className="holidays-item" key={idx}>
                            <div className="holidays-key">{counter.label}</div>
                            <div className="holidays-value">{typeof counter.value === 'number' ? this.format(counter.value) : counter.value}</div>
                        </div>
                    ))}
                </div>

                <UpgradeModal
                    show={this.state.showUpgradeModal}
                    onClose={() => this.setState({ showUpgradeModal: false })}
                    feature={this.state.upgradeFeature}
                    requiredPlan="Pro"
                />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    hideModal: () => dispatch(hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(showModal({ modalProps, modalType }));
    },
});

export default connect(null, mapDispatchToProps)(withTranslation()(AbsenceSidebar));
